( function( $, document, window ) {
	'use strict';

	function combineClass( className, blockId ) {
		return `${className}-${blockId}`;
	}

	function checkOverflow(swiperInstance) {
		const class_name = 'swiper--no-navigation'
		if (swiperInstance.isBeginning && swiperInstance.isEnd) {
			// All slides are visible, add a class to hide navigation
			swiperInstance.el.classList.add( class_name );
			swiperInstance.el.classList.add( class_name );
		} else {
			// Not all slides are visible, ensure navigation is shown
			swiperInstance.el.classList.remove( class_name );
		}
	}

	$( function() {
		$( '.js-card-collection' ).each( function( index, element ) {
			const blockId = $(this).data('block-id');

			const config = {
				activeClass: 'is-active',
				carouselEl: combineClass( '.js-carousel', blockId ),
				paginationEl: combineClass( '.js-carousel-pagination', blockId ),
				navigationEl: combineClass( '.js-carousel-navigation', blockId ),
				prevEl: combineClass( '.js-carousel-navigation-prev', blockId ),
				nextEl: combineClass( '.js-carousel-navigation-next', blockId ),
				slidesPerView: $(this).data('slide-count') ?? 3,
			};

			const $pagination = $( config.paginationEl );
			const $navigation = $( config.navigationEl );

			const controlsVisibility = function () {
				if ( this.pagination.bullets.length > 1 ) {
					$pagination.addClass( config.activeClass );
					$navigation.addClass( config.activeClass );
				} else {
					$pagination.removeClass( config.activeClass );
					$navigation.removeClass( config.activeClass );
				}
			};

			new Swiper( config.carouselEl, {
				direction: 'horizontal',
				spaceBetween: 0,
				slidesPerView: 'auto',
				loop: false,
				watchOverflow: true,

				navigation: {
					prevEl: config.prevEl,
					nextEl: config.nextEl,
				},

				pagination: {
					el: config.paginationEl,
					clickable: true,
				},

				breakpoints: {
					1280: {
						slidesPerView: 3,
						noSwiping: true
					},
					1440: {
						slidesPerView: config.slidesPerView,
						noSwiping: true
					}
				},

				on: {
					init: function () {
						checkOverflow(this);
						//controlsVisibility;
					},
					resize: function () {
						checkOverflow(this);
						//controlsVisibility;
					},
				}
			});
		});
	} );

} )( jQuery, document, window );
